import { BaseRequest } from '@/network/requests/BaseRequest'
import { process_group_detail } from '@/interfaces/process_group_detail'
import { $in } from '../util/QueryBuilder'

export const processGroupDetailRequest = BaseRequest.build<process_group_detail>('process_group_detail')

/**
 * 获取某个工序组的工序详情。
 * @param group_id
 */
export const getProcessGroupDetails = (group_id: string) => {
	return processGroupDetailRequest.queryAll({ process_group_id: group_id }, undefined, { sequence: 1 })
}

/**
 * 获取工序组集合的工序详情。
 * @param group_id_array
 */
export const getProcessGroupDetailsByGroupIdArray = (group_id_array: string[]) => {
	return processGroupDetailRequest.queryAll({ process_group_id: $in(group_id_array) })
}
